import createSvgIcon from '@ixigo/icons/utils/createSvgIcon';

export const TollFilled = createSvgIcon(
	<path
		fillRule="evenodd"
		clipRule="evenodd"
		d="M3.83186 3.66514C3.97763 3.27374 4.35131 3.01416 4.76897 3.01416H16.713C17.1306 3.01416 17.5043 3.27374 17.6501 3.66514L18.2385 5.24511C18.4819 5.89852 17.9987 6.59413 17.3014 6.59413H16.741V11.9242L19.7572 8.90802C20.0501 8.61513 20.5249 8.61513 20.8178 8.90802C21.1107 9.20092 21.1107 9.67579 20.8178 9.96868L16.741 14.0455V19.914C16.741 20.4663 16.2933 20.914 15.741 20.914H14.7409V16.0456L11.2712 19.5153C10.9783 19.8082 10.5035 19.8082 10.2106 19.5153C9.91768 19.2224 9.91768 18.7475 10.2106 18.4546L13.7511 14.9141L11.6306 14.9141L10.4989 16.0528L9.24098 17.2338V20.914H5.74098C5.18869 20.914 4.74098 20.4663 4.74098 19.914V6.59413H4.18052C3.48327 6.59413 3.00005 5.89852 3.24341 5.24511L3.83186 3.66514ZM6.74098 6.59413H14.741V13.5941H6.74098V6.59413Z"
		fill="currentColor"
	/>,
	'TollFilled',
);

export default TollFilled;
